module.exports = __webpack_public_path__ + "assets/img/login-light@2x.f9a09de5.png";